import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import {
  regionsTabsQueryParamName,
  regionsTabs,
} from '@app/pages/discover/regions/constants'
import { fullName } from '@app/util/helpers'
import { DiscussionCard } from '../../discussions'
import { SectionHeader } from '../../sectionHeader/SectionHeader'
import { useTranslations } from '@i18n/useLanguage'
import useDateFormat from '@app/util/useDateFormat'
import { PostViewModel } from 'functions/app/thread/view-latest'

export type ThreadContentSectionType = {
  type: 'thread'
  title: string
  items: PostViewModel[]
}

export const ThreadContentSection = ({
  title,
  items,
}: ThreadContentSectionType) => {
  const t = useTranslations().app
  const dateFormat = useDateFormat()

  if (items.length === 0) return null

  return (
    <Column alignItems="stretch" gap={0}>
      <SectionHeader
        title={title}
        seeMore={t.common.seeMore}
        toRoute={`?${regionsTabsQueryParamName}=${regionsTabs.discussion}`}
      />
      <Row style={{ gap: '1rem' }}>
        {items.slice(0, 6).map((p) => (
          <DiscussionCard
            key={p.id}
            authorName={p.author ? fullName(p.author) : t.common.unknown}
            authorAvatar={p.author?.avatar}
            date={p.createdAt ? dateFormat(new Date(p.createdAt)) : ''}
            content={p.content ?? ''}
            likes={p.viewers?.count ?? 0}
            replies={p.replies?.count ?? 0}
            style={{ flex: 1 }}
          />
        ))}
      </Row>
    </Column>
  )
}
